export default __webpack_public_path__ + "static/media/project2.6639c502.png";